var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-1"},[_c('v-col',{staticClass:"text-right",attrs:{"cols":"3"}},[_c('strong',[_vm._v(_vm._s(_vm.label)+":")])]),_c('v-col',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }